module.exports = __webpack_public_path__ + "images/home/masters/quote-7e944d4eb8afb6e41ce171241f96d1df.svg";